// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2jkqi","content":"RecentSearches_content__22IVT"};